export default __webpack_public_path__ + "static/media/Insurance_Agent.c232fc03.svg";